import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
// import AccountForm from "../../../global/components/adminInfo";
// import AccountCreationModal from "../../../global/components/AccountCreationModal";
// import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DeviceIcon from "../../../assets/images/vectors/SideBarIcons/DeviceIcon";
import { macValidator } from "../../../global/utils/macValidator";
import useGet from "../../../global/hooks/useGet";
import { DuplicateMacModal } from "../../Device/Components/DuplicateMacModal";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";

export const ProductionItemAddbyCount = ({
  isModalForm,
  onCancel,
  productionRefetch,
  LicenseNo,
}) => {
  const [form] = Form.useForm();
  const { id, itemid } = useParams();
  const [modal, setModal] = useState(null);

  const navigate = useNavigate();

  const postUrl = `${process.env.REACT_APP_API_URL}/api/${id}/production-items/bulk-create-by-count/`;
  const url =
    id &&
    itemid &&
    `${process.env.REACT_APP_API_URL}/api/${id}/production-items/${itemid}/`;
  // const modifiedBillingCycles = getModifiedResponse(optionData, "bill_cycles");
  // const modifiedAutoBilling = getModifiedResponse(optionData, "auto_billings");
  const { data, loading, error, refetch } = useGet(url);

  const itemCount = data?.data?.ItemCount;
  const deviceCount = data?.data?.DeviceCount;
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
      production_item_id: Number(itemid),
      LicenseNo: LicenseNo,
    };
    try {
      await postAction(modValues);
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  useEffect(() => {
    if (data?.data) {
      form.setFieldValue("count", itemCount - deviceCount);
    }
  }, [data?.data]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      // console.log(postData);

      const details = postData?.data?.details || [];
      const hasDuplicates = details.some((item) => item?.status === 400);

      if (hasDuplicates) {
        // Show modal with all details (both duplicates and successes)
        setModal(details);
        isModalForm && productionRefetch();
        // isModalForm && onCancel();
      } else {
        // All items were successful
        openConfirmNotification("Success");
        isModalForm && productionRefetch();
        isModalForm ? onCancel() : navigate(-1);
      }
    }
  }, [postError, postData, postLoading]);

  const breadcrumbItems = [
    {
      label: "Production Device",
      href: `/productionitem/${id}/info/${itemid}`,
    },
    {
      label: "Add by Count",
      href: `/addproductionbycount/${id}/info/${itemid}`,
    },
  ];

  const buttonsData = [
    {
      label: "Apply",
      icon: <CheckCircleOutlined />,
      onClick: () => form.submit(),
    },
    {
      label: "Cancel",
      icon: <CloseOutlined />,
      onClick: () => {
        navigate(-1);
      },
    },
  ];

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}

          <div
            className={`${
              isModalForm ? "" : "bg-white overflow-hidden border rounded-[4px]"
            }`}
          >
            {!isModalForm && (
              <div className="flex items-center bg-gray-200 p-2.5">
                <DeviceIcon className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                  Device
                </span>
              </div>
            )}

            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Start MAC"
                    name="start_mac"
                    required
                    rules={[{ validator: macValidator }]}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} span={24}>
                  <CustomInput
                    label="Device Count"
                    name="count"
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            typeof itemCount === "number" &&
                            typeof deviceCount === "number" &&
                            value > itemCount - deviceCount
                          ) {
                            return Promise.reject(
                              new Error(
                                `Device Count must be less than or equal to ${
                                  itemCount - deviceCount
                                }!`
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Form>
      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
            loading={postLoading}
            disabled={postLoading}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onCancel}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}
      <DuplicateMacModal
        isModalOpen={modal !== null}
        setModal={setModal}
        modal={modal}
        isModalForm={isModalForm}
      />
    </>
  );
};
